


















import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  name: 'ImageCaption',
  props: { blok: { type: Object } },
  setup(props) {
    const blok = props.blok || {};
    function inMin(time) {
      const min = Math.floor(time / 60);
      const sec = Math.floor(time % 60);
      const secPadded = `${sec < 10 ? '0' : ''}${sec}`;
      return `${min}:${secPadded}`;
    }

    const duration = computed(() => inMin(blok.newAudioFile?.duration > 0 ? blok.newAudioFile?.duration : blok.duration));
    console.log(blok.newAudioFile?.duration);
    const audioFile = computed(() => {
      if (blok.newAudioFile && blok.newAudioFile.audio && blok.newAudioFile.audio !== '') {
        return blok.newAudioFile.audio;
      }
      if (blok.audioFile && blok.audioFile.filename && blok.audioFile.filename !== '') {
        return blok.audioFile.filename;
      }
      return '';
    });
    return {
      inMin,
      duration,
      audioFile,
    };
  },
});
